module.exports = __webpack_public_path__ + "img/1-2.22cb8560.jpg";